import { render } from "./TranscriptsView.vue?vue&type=template&id=8f66f73a"
import script from "./TranscriptsView.vue?vue&type=script&lang=js"
export * from "./TranscriptsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__